import { render, staticRenderFns } from "./ViewCertificate.vue?vue&type=template&id=3e89f6ce&scoped=true&"
import script from "./ViewCertificate.vue?vue&type=script&lang=js&"
export * from "./ViewCertificate.vue?vue&type=script&lang=js&"
import style0 from "./ViewCertificate.vue?vue&type=style&index=0&id=3e89f6ce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e89f6ce",
  null
  
)

export default component.exports